<template> 
  <div>
    <div
      class="py-5"
    /> 
    <v-footer 
      padless
      fixed
    >
      <v-row no-gutters>
        <v-col 
          class="text-center py-3"
        >
          <b>{{ userSelect.length }}</b>
          <h6>{{ $t('unit.list') }}</h6>
        </v-col>  
        <v-col
          cols="10"
          class="py-3 d-flex justify-end"
        >
          <Group 
            :x-large="true"
            :color="'blue'"  
            @addItemFromDialog="addItemFromDialog"
          />
          <v-btn  
            depressed
            dark
            class="mx-1"
            color="var(--bg-secondary-color)" 
            large
            @click="viewBet"
          >
            {{ $t('views-bet-items') }}  
          </v-btn> 
        </v-col>  
      </v-row>
      <resultpricecard 
        ref="dialogPrice" 
        :user-select="userSelect"
        :number-conditions="numberConditions"   
        :voucher="voucher"
        @addItemFromDialog="addItemFromDialog"  
        @switchNumberToggle="switchNumberToggle"
        @removeSameNumber="removeSameNumber"
        @clearAll="clearAll" 
        @delValue="delValue"
        @load="$emit('load')"
      />
    </v-footer>
  </div>
</template>
<script>
import Group from '@/components/Dialog/DialogGropnumberPullpoll'
import resultpricecard from './childs/ResultPriceCard'
export default {
  components : {
    Group,
    resultpricecard
  },
  props : { 
    numberConditions:{
      type:Array,
      default:()=>{
        return []
      }
    },
    userSelect:{
      type:Array,
      default:()=>{
        return []
      }
    }, 
    voucher:{
      type:Object,
      default:()=>{}
    }  
  },
  methods : {
    delValue (number) { 
      this.$emit('delValue',
      null,
      number.number,
      number.number_type_id,
      number.selectNineteen,
      number.selectFrontRoot,
      number.selectBackRoot ) 
    },
    removeSameNumber (item) {
      this.$emit('removeSameNumber',item)
    },
    clearAll (){
      this.$emit('clearAll')
    },
    addItemFromDialog (item){
      this.$emit('addItemFromDialog',item)
    }, 
    viewBet () {
      this.$refs.dialogPrice.open()
    },
    switchNumberToggle () {
      this.$emit('switchNumberToggle')
    }, 
  }
}
</script>